import React from "react";
import { createPortal } from "react-dom";
import { Close } from "@mui/icons-material";

export default function Modal({ onClose, children }) {
  return createPortal(
    <BackgroundShade>
      <div className="modal-container" style={{ overflowY: "scroll" }}>
        <button onClick={() => onClose()}>
          <Close style={{ color: "var(--text)" }} />
        </button>
        {children}
      </div>
    </BackgroundShade>,

    document.getElementById("modal"),
  );
}

function BackgroundShade({ children }) {
  return <div className="modal-background">{children}</div>;
}
